/**
 * Properties configuration for the WebHelp application
 */
const properties = {
    'default.language': 'en',
    'use.stemming': 'false',
    'webhelp.enable.search.autocomplete': 'true',
    'webhelp.enable.template.js.module.loading': 'no',
    'webhelp.language': 'en',
    'webhelp.publication.toc.links': 'chapter',
    'webhelp.publication.toc.tooltip.position': 'right',
    'webhelp.search.enable.pagination': 'true',
    'webhelp.search.page.numberOfItems': '10',
    'webhelp.search.ranking': 'true',
    'webhelp.show.expand.collapse.sections': 'no',
    'webhelp.show.main.page.tiles': 'yes',
    'webhelp.show.main.page.toc': 'no',
    'webhelp.top.menu.depth': '3',
    'webhelp.topic.collapsible.elements.initial.state': 'expanded',
};

export default properties;
